import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { rooms } from "./Rooms";
import { Swiper, SwiperSlide } from "swiper/react";
import Lightbox from "react-image-lightbox";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "react-image-lightbox/style.css";
import { Navigation, Autoplay } from "swiper/modules";
import { useTranslation } from "react-i18next";
const DetailRoom = () => {
  const location = useLocation();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const roomType = location.search.split("?")[1] || {};
  const roomDetails = rooms.find((room) => room.type === Number(roomType));
  const [isOpen, setIsOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);
  return (
    <section className="py-[10px] ">
      <div className="relative mb-8 xl:h-[450px] sm:h-350px] ssx:h-[250px]">
        <img
          src={roomDetails?.image[0]}
          alt="Hotel Lobby"
          className="w-full h-full absolute top-0 left-0 right-0 object-cover rounded-lg shadow-lg"
        />
      </div>
      <h2 className="text-2xl font-[500] text-left font-cormorant">
        {roomDetails?.header}
      </h2>
      <p className="bg-gray-400 h-[1px] my-[9px]"></p>
      <section className="py-12  flex flex-col md:flex-row items-center space-y-6 md:space-y-0 md:space-x-6">
        <div className="md:w-1/2">
          <div className="ml-[100px] sm:ml-[0px] ssx:ml-0">
            <h2 className="text-[35px] font-cormorant text-[#D4AF37] uppercase">
              {t("HOTEL_NAME")}
            </h2>
            <h4 className="text-[28px] font-cormorant">
              {roomDetails.header1}
            </h4>
            <p className="mt-4 text-gray-600">{roomDetails.content}</p>
            <button
              onClick={() => {
                navigate("/promotions");
              }}
              className="mt-4 text-[14px] border-[1px] uppercase border-yellow-500 text-black px-4 py-2 rounded"
            >
              {t("BOOK_NOW")}
            </button>
          </div>
        </div>
        <div className="md:w-1/2">
          <div className="overflow-hidden">
            <img
              src={roomDetails?.image[1]}
              alt="Hotel Lobby"
              className="w-full rounded"
            />
          </div>
        </div>
      </section>
      <div className="flex justify-center">
        <div className="relative mb-8 w-full h-[400px] sm:h-[250px] ssx:h-[250px] ">
          <Swiper
            spaceBetween={10}
            slidesPerView={3}
            navigation={{
              nextEl: ".swiper-buttont-next",
              prevEl: ".swiper-buttont-prev",
            }}
            autoplay={{ delay: 2000, disableOnInteraction: false }}
            pagination={{ clickable: true }}
            modules={[Navigation, Autoplay]}
            className="rounded-lg shadow-lg"
          >
            {roomDetails.image.map((image, index) => (
              <SwiperSlide key={index}>
                <img
                  src={image}
                  alt={`Slide ${index + 1}`}
                  className="w-full h-[400px] sm:h-[250px] ssx:h-[250px] object-cover cursor-pointer"
                  onClick={() => {
                    setPhotoIndex(index);
                    setIsOpen(true);
                  }}
                />
              </SwiperSlide>
            ))}
          </Swiper>
          <div className="swiper-buttont-prev absolute top-1/2 left-0 transform -translate-y-1/2 z-10 cursor-pointer text-white bg-black bg-opacity-50 p-2 rounded-full">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-6 h-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M15 19l-7-7 7-7"
              />
            </svg>
          </div>
          <div className="swiper-buttont-next absolute top-1/2 right-0 transform -translate-y-1/2 z-10 cursor-pointer text-white bg-black bg-opacity-50 p-2 rounded-full">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-6 h-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M9 5l7 7-7 7"
              />
            </svg>
          </div>
        </div>
      </div>
      {isOpen && (
        <Lightbox
          mainSrc={roomDetails.image[photoIndex]}
          nextSrc={
            roomDetails.image[(photoIndex + 1) % roomDetails.image.length]
          }
          prevSrc={
            roomDetails.image[
              (photoIndex + roomDetails.image.length - 1) %
                roomDetails.image.length
            ]
          }
          onCloseRequest={() => setIsOpen(false)}
          onMovePrevRequest={() =>
            setPhotoIndex(
              (photoIndex + roomDetails.image.length - 1) %
                roomDetails.image.length
            )
          }
          onMoveNextRequest={() =>
            setPhotoIndex((photoIndex + 1) % roomDetails.image.length)
          }
        />
      )}
      <div className="text-center">
        <h2 className="font-cormorant text-[30px] text-[#fbbe17]">
          {roomDetails.header}
        </h2>
        <p className="font-cormorant text-[28px]">{roomDetails.header1}</p>
        <p className=" text-[20px]">
          {t("Acreage")} {roomDetails.dientich}, {t("Price")}{" "}
          {roomDetails.price}
        </p>
      </div>
      <section className="py-12 flex flex-col md:flex-row  space-y-6 md:space-y-0 md:space-x-6">
        <div className="md:w-1/2">
          <div className="overflow-hidden">
            <img
              src={roomDetails?.image[2]}
              alt="Hotel Lobby"
              className="w-full rounded hover:scale-110 duration-300"
            />
          </div>
        </div>
        <div className="md:w-1/2">
          <div className="ml-[10px]">
            <h2 className="text-[28px] font-cormorant font-[500]">
              {t("Amenities")}:
            </h2>
            <ul className="list-disc list-inside mt-4 text-gray-600 text-[18px]">
              {roomDetails?.amenities?.map((amenity, i) => (
                <li key={i}>{amenity}</li>
              ))}
            </ul>
          </div>
        </div>
      </section>
      <section className="py-12 flex flex-col md:flex-row items-center space-y-6 md:space-y-0 md:space-x-6">
        <div className="md:w-1/2">
          <div className="ml-[10px]">
            <h2 className="text-[28px] font-cormorant font-[500]">
              {t("ROOM_RATES_ABOVE_INCLUDE")}
            </h2>
            <ul className="list-disc list-inside mt-4 text-gray-600 text-[18px]">
              <li>{t("FREE_TEA_COFFEE_WATER")}</li>
              <li>{t("DAILY_HOUSEKEEPING")}</li>
              <li>{t("FREE_WIFI")}</li>
              {/* <li>{t("VAT_INCLUDED")}</li> */}
            </ul>
          </div>
        </div>
        <div className="md:w-1/2">
          <div className="overflow-hidden">
            <img
              src={roomDetails?.image[3]}
              alt={t("HOTEL_LOBBY")}
              className="w-full rounded hover:scale-110 duration-300"
            />
          </div>
        </div>
      </section>
      <section className="py-12 flex flex-col md:flex-row items-center space-y-6 md:space-y-0 md:space-x-6">
        <div className="md:w-1/2">
          <div className="overflow-hidden">
            <img
              src={roomDetails?.image[4]}
              alt={t("HOTEL_LOBBY")}
              className="w-full rounded hover:scale-110 duration-300"
            />
          </div>
        </div>
        <div className="md:w-1/2">
          <div className="ml-[10px]">
            <h2 className="text-[28px] font-cormorant font-[500]">
              {t("CHILD_SURCHARGE_POLICY")}
            </h2>
            <ul className="list-disc list-inside mt-4 text-gray-600 text-[18px]">
              <li>{t("FREE_FOR_CHILDREN_UNDER_6")}</li>
              <li>{t("CHILDREN_OVER_10_SURCHARGE")}</li>
            </ul>
            <h2 className="text-[28px] font-cormorant font-[500]">
              {t("CHECKIN_CHECKOUT_POLICY")}
            </h2>
            <ul className="list-disc list-inside mt-4 text-gray-600 text-[18px]">
              <li>{t("CHECKIN_TIME")}</li>
              <li>{t("CHECKOUT_TIME")}</li>
            </ul>
          </div>
        </div>
      </section>
    </section>
  );
};

export default DetailRoom;
